import { OptionType } from '@evinced-private/ui-common';

import { transformUsageDataResults as transformUsageDataResultsGeneric } from 'src/common/helpers/GQLRequestsHelper/QueryResultsTransformHelper';
import { SummaryItem } from 'src/common/interfaces/SummaryItem';

import { MobileSdkUsageDataQuery } from '../MobileSdkUsageData.generated';

const TESTS_METRIC_LABEL = 'Tests';
const ISSUES_METRIC_LABEL = 'Issues';
const CRITICAL_ISSUES_METRIC_LABEL = 'Critical issues';

export const transformMobileSdkUsageDataResults = (
	rawResults: MobileSdkUsageDataQuery,
	testPeriod?: OptionType
): SummaryItem[] => {
	const lastNDaysResults = rawResults?.last_n_days?.[0];
	const last2NDaysResults = rawResults?.last_2n_days?.[0];

	const lastPeriodTestsCount = lastNDaysResults?.run_id_count ?? 0;
	const twoPeriodsTestsCount = last2NDaysResults?.run_id_count ?? 0;

	const lastPeriodIssuesCount = lastNDaysResults?.total_issues_sum ?? 0;
	const twoPeriodsIssuesCount = last2NDaysResults?.total_issues_sum ?? 0;

	const lastPeriodCriticalIssues = lastNDaysResults?.critical_issues_sum ?? 0;
	const twoPeriodsAgoCriticalIssues = last2NDaysResults?.critical_issues_sum ?? 0;

	const criticalIssuesItem = transformUsageDataResultsGeneric(
		lastPeriodCriticalIssues,
		twoPeriodsAgoCriticalIssues,
		CRITICAL_ISSUES_METRIC_LABEL,
		testPeriod
	);

	return [
		transformUsageDataResultsGeneric(
			lastPeriodTestsCount,
			twoPeriodsTestsCount,
			TESTS_METRIC_LABEL,
			testPeriod
		),
		transformUsageDataResultsGeneric(
			lastPeriodIssuesCount,
			twoPeriodsIssuesCount,
			ISSUES_METRIC_LABEL,
			testPeriod
		),
		{
			...criticalIssuesItem,
			falsePositive: true
		}
	];
};
